<ion-app>
    @if (isAppInitialized() && !splashScreenStateService.splashScreenIsEnabled()) {
        <lib-curafida-side-menu [contentID]="'curafida-content'"></lib-curafida-side-menu>
        @if (toolbarService.toolbarType()) {
            @if (toolbarService.toolbarType() === 'STANDARD') {
                <lib-curafida-toolbar></lib-curafida-toolbar>
            } @else if (toolbarService.toolbarType() === 'MINIMAL') {
                <toolbar-patient></toolbar-patient>
            }
        }

        <ion-content
            class="mini-mode-background-image"
            [style.background-image]="backgroundImageUrl()"
            [style.--background]="'var(--main-content-background)'">
            <ion-router-outlet
                [swipeGesture]="false"
                id="curafida-content">
            </ion-router-outlet>
        </ion-content>
    }
    <lib-splash></lib-splash>
    <ion-footer>
        <lib-curafida-footer-console-log></lib-curafida-footer-console-log>
    </ion-footer>
</ion-app>
